/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class VehicleFuelCardDto extends JSONable {
  uuid = '';
  owner = '';
  vehicleUuid: string | null = null;
  series: string | null = null;
  provider: string | null = null;
}
